import { render } from "./icon-plus.svg?vue&type=template&id=8bf397d0?inline"
const script = {}
script.render = render

export default script